(() => {
  'use strict';
  if (window.KorolGift) return;
  const cfg = JSON.parse(document.getElementById('kw-gift-config')?.textContent || '{}');
  const rootUrl = cfg.root || window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const roots = () => Array.from(document.querySelectorAll('[data-korol-fs]'));
  const knownCodes = new Set([cfg.code, ...(cfg.codes || [])].filter(Boolean).map(code => code.trim().toUpperCase()));
  const debounceMs = typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300;
  const edits = new Map();
  let chain = Promise.resolve(), jobs = 0, writes = 0, revision = 0, verified = -1;
  let timer, syncQueued = false, syncAgain = false, failed = false, lastCart = null, giftMessage = '', codeMessage = '', checkoutPromise = null;
  let eligible = new Set(), small = 63779691200842, big = 63854596194634;
  const messages = el => JSON.parse(el.querySelector('[data-korol-fs-messages]')?.textContent || '{}');
  const isLocked = () => jobs > 0 || writes > 0 || edits.size > 0 || verified !== revision;
  function configuration() {
    const el = roots()[0];
    if (!el) return;
    small = Number(el.dataset.small);
    big = Number(el.dataset.big);
    eligible = new Set((el.dataset.elig || '').split(',').filter(Boolean).map(Number));
  }
  function state(cart) {
    configuration();
    const gifts = (cart.items || []).filter(item => item.variant_id === small || item.variant_id === big);
    const n = (cart.items || []).reduce((sum, item) => sum + (!gifts.includes(item) && eligible.has(item.variant_id) ? item.quantity : 0), 0);
    const codes = cart.discount_codes || [];
    const wiCodes = codes.filter(item => knownCodes.has((item.code || '').trim().toUpperCase()));
    const wi = wiCodes.length > 0;
    const target = n >= 2 ? (wi ? big : small) : null;
    const free = gifts.length === 1 && gifts[0].variant_id === target && gifts[0].quantity === 1 && gifts[0].final_line_price === 0 && (!wi || wiCodes.some(item => item.applicable === true));
    return { gifts, n, codes, wiCodes, wi, target, free };
  }
  function feedback() {
    const locked = isLocked();
    roots().forEach(el => {
      const t = messages(el), ready = el.dataset.offerReady === 'true';
      el.setAttribute('aria-busy', String(locked));
      const cb = el.querySelector('[data-korol-fs-cb]');
      if (cb) cb.disabled = locked || !ready;
      const opt = el.querySelector('[data-korol-fs-opt]');
      if (opt) { opt.hidden = locked || !ready; opt.classList.toggle('is-busy', locked); }
      const txt = el.querySelector('[data-korol-fs-txt]');
      if (txt) txt.innerHTML = locked ? (t[failed ? 'error' : 'pending'] || '') : (t[el.dataset.displayKey] || '');
      const status = el.querySelector('[data-korol-fs-status]');
      if (status) { status.textContent = locked ? '' : (t[giftMessage] || ''); status.hidden = !status.textContent; }
    });
    document.querySelectorAll('[data-kw-apply], [data-kw-remove]').forEach(el => { el.disabled = locked && !failed; });
    if (failed) document.querySelectorAll('[data-kw-code-status]').forEach(el => { el.textContent = cfg.messages?.error || ''; });
    document.querySelectorAll('[name="checkout"]').forEach(el => { el.setAttribute('aria-busy', String(locked)); });
    document.querySelectorAll('.additional-checkout-buttons').forEach(el => { el.style.pointerEvents = locked ? 'none' : ''; });
  }
  function invalidate() { revision++; verified = -1; failed = false; feedback(); }
  function render(cart) {
    lastCart = cart;
    const s = state(cart);
    roots().forEach(el => {
      const t = messages(el);
      el.dataset.wi = String(s.wi);
      el.dataset.offerReady = String(s.n >= 2);
      el.dataset.displayKey = s.free ? (s.wi ? 'w_added' : 'p_added') : (s.wi ? 'w' : 'p') + Math.min(s.n, 2);
      el.querySelector('[data-korol-fs-fill]').style.width = (s.n <= 0 ? 0 : s.n === 1 ? 50 : 100) + '%';
      el.querySelector('[data-korol-fs-l]').textContent = s.wi ? t.lw : t.l;
      ['m', 'l'].forEach(key => el.querySelector('[data-korol-fs-' + key + ']').classList.toggle('is-done', s.free));
      el.querySelector('[data-korol-fs-cbt]').innerHTML = s.wi ? t.cbw : t.cb;
      el.querySelector('[data-korol-fs-cb]').checked = s.free;
      el.querySelector('[data-korol-fs-wi]').hidden = !s.wi;
      el.querySelector('[data-korol-fs-wit]').textContent = s.free && s.wi ? t.wi : t.wi_pending;
      el.querySelector('[data-korol-fs-wirm]').textContent = t.wirm;
    });
    const codes = s.codes.map(item => item.code).filter(Boolean);
    let text = codeMessage;
    if (!text && s.wi) text = s.free ? cfg.messages?.success : cfg.messages?.waiting;
    if (!text && !s.wi && codes.length) text = s.codes.some(item => item.applicable === true) ? cfg.messages?.applied : cfg.messages?.invalid;
    document.querySelectorAll('[data-kw-code-status]').forEach(el => { el.textContent = text || ''; });
    document.querySelectorAll('[data-kw-remove]').forEach(el => { el.hidden = !codes.length; });
    document.querySelectorAll('[data-kw-login]').forEach(el => { el.hidden = true; });
    document.querySelectorAll('[data-kw-code-input]').forEach(el => { if (el !== document.activeElement) el.value = codes.join(', '); });
    feedback();
  }
  const request = async (path, data) => {
    const response = await nativeFetch(rootUrl + path, data === undefined
      ? { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }
      : { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) throw new Error('Cart request failed');
    return result;
  };
  function enqueue(work) {
    jobs++;
    feedback();
    const result = chain.then(work);
    chain = result.catch(() => {}).then(() => { jobs--; feedback(); });
    return result;
  }
  const lineFor = (cart, edit) => {
    const exact = cart.items.find(item => item.key === edit.key);
    if (exact) return exact;
    const matches = cart.items.filter(item => item.variant_id === edit.variantId && (!edit.reference || (JSON.stringify(item.properties || {}) === JSON.stringify(edit.reference.properties || {}) && item.selling_plan_allocation?.selling_plan?.id === edit.reference.selling_plan_allocation?.selling_plan?.id)));
    return matches.length === 1 ? matches[0] : null;
  };
  function settleEdits(cart) {
    for (const [key, edit] of edits) {
      const item = lineFor(cart, edit);
      const inputs = Array.from(document.querySelectorAll('.quantity__input')).filter(input => input.dataset.quantityLineKey === key);
      if ((item && item.quantity === edit.quantity) || (!item && edit.quantity === 0) || (Date.now() >= edit.until && inputs.every(input => Number(input.value) === (item?.quantity || 0)))) edits.delete(key);
    }
  }
  async function normalize(cart, selected) {
    let changed = false, added = false;
    for (let pass = 0; pass < 5; pass++) {
      const s = state(cart), updates = {};
      let keep = false;
      s.gifts.forEach(item => {
        if (item.variant_id !== s.target || keep) updates[item.key] = 0;
        else { keep = true; if (item.quantity !== 1) updates[item.key] = 1; }
      });
      if (Object.keys(updates).length) { cart = await request('cart/update.js', { updates }); changed = true; continue; }
      if (s.gifts.length && !s.free) {
        giftMessage = 'paid';
        cart = await request('cart/update.js', { updates: Object.fromEntries(s.gifts.map(item => [item.key, 0])) });
        changed = true;
        selected = false;
        continue;
      }
      if (selected && s.target && !s.gifts.length && !added) {
        added = true;
        await request('cart/add.js', { items: [{ id: s.target, quantity: 1 }] });
        cart = await request('cart.js');
        changed = true;
        continue;
      }
      return { cart, changed };
    }
    throw new Error('Gift could not be verified');
  }
  async function redraw(cart) {
    const targets = [
      { id: document.getElementById('main-cart-items')?.dataset.id, selector: '#main-cart-items .js-contents' },
      { id: document.getElementById('main-cart-footer')?.dataset.id, selector: '#main-cart-footer .js-contents' },
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }
    ].filter(target => target.id && document.querySelector(target.selector));
    if (targets.length) {
      const response = await nativeFetch(rootUrl + 'cart?sections=' + targets.map(target => target.id).join(','), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart rendering failed');
      const sections = await response.json();
      const replacements = targets.map(target => {
        if (!sections[target.id]) throw new Error('Missing cart section');
        const html = new DOMParser().parseFromString(sections[target.id], 'text/html');
        const replacement = html.querySelector(target.selector);
        return { ...target, content: replacement ? replacement.innerHTML : target.id === 'cart-icon-bubble' ? html.body.innerHTML : null };
      });
      observer.disconnect();
      try {
        replacements.forEach(({ selector, content }) => { const current = document.querySelector(selector); if (current && content !== null) current.innerHTML = content; });
        document.querySelectorAll('cart-items, cart-drawer-items, cart-drawer, #main-cart-footer').forEach(el => el.classList.toggle('is-empty', cart.item_count === 0));
        document.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => document.querySelector('cart-drawer')?.close());
      } finally { observer.observe(document.body, { childList: true, subtree: true }); }
    }
  }
  async function finish(cart, changed, start) {
    settleEdits(cart);
    if (changed) await redraw(cart);
    if (start === revision && writes === 0 && edits.size === 0) { failed = false; verified = revision; render(cart); }
    else {
      verified = -1;
      feedback();
      if (start !== revision || writes > 0) refresh();
      else if (edits.size) {
        const wait = Math.max(...Array.from(edits.values()).map(edit => edit.until - Date.now())) + 20;
        if (wait > 20) refresh(wait);
      }
    }
  }
  function refresh(delay = 80) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (syncQueued) { syncAgain = true; return; }
      syncQueued = true;
      enqueue(async () => {
        const start = revision;
        try { const result = await normalize(await request('cart.js')); await finish(result.cart, result.changed, start); }
        catch (error) { verified = -1; failed = true; giftMessage = 'error'; codeMessage = cfg.messages?.error || ''; feedback(); }
        finally { syncQueued = false; if (syncAgain) { syncAgain = false; refresh(); } }
      }).catch(() => {});
    }, delay);
  }
  function editFrom(input) {
    const key = input.dataset.quantityLineKey;
    if (!key) return null;
    return { key, index: Number(input.dataset.index), quantity: Number(input.value), variantId: Number(input.dataset.quantityVariantId), reference: lastCart?.items.find(item => item.key === key), until: Date.now() + debounceMs + 100 };
  }
  function trackInput(event) {
    if (!event.target.matches('.quantity__input')) return;
    const edit = editFrom(event.target);
    if (!edit) return;
    edits.set(edit.key, edit);
    invalidate();
    refresh(debounceMs + 120);
  }
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || String(args[0]);
    if (!/\/cart\/(add|change|update|clear)(?:\.|\?|$)/.test(url)) return nativeFetch(...args);
    let body, edit;
    if (/\/cart\/change(?:\.|\?|$)/.test(url) && typeof args[1]?.body === 'string') {
      try {
        body = JSON.parse(args[1].body);
        if (body.line) {
          const pending = Array.from(edits.values()).filter(item => item.index === Number(body.line) && item.quantity === Number(body.quantity));
          const input = Array.from(document.querySelectorAll('.quantity__input')).find(el => Number(el.dataset.index) === Number(body.line));
          if (pending.length === 1) edit = pending[0];
          else if (input) edit = editFrom(input);
        }
      } catch (error) {}
    }
    writes++;
    giftMessage = '';
    codeMessage = '';
    invalidate();
    return enqueue(async () => {
      let callArgs = args;
      if (edit && body) {
        const cart = await request('cart.js'), item = lineFor(cart, edit);
        if (!item) return new Response(JSON.stringify({ errors: window.cartStrings?.error || cfg.messages?.error || 'Cart changed. Please try again.' }), { status: 200, headers: { 'Content-Type': 'application/json' } });
        const payload = { ...body, id: item.key };
        delete payload.line;
        callArgs = [args[0], { ...args[1], body: JSON.stringify(payload) }];
      }
      const response = await nativeFetch(...callArgs);
      try { const cart = await response.clone().json(); if (Array.isArray(cart.items)) settleEdits(cart); } catch (error) {}
      return response;
    }).finally(() => { writes--; refresh(); });
  };
  async function operation(work) {
    invalidate();
    giftMessage = '';
    codeMessage = '';
    return enqueue(async () => {
      const start = revision;
      try { const result = await work(await request('cart.js')); await finish(result.cart, true, start); }
      catch (error) {
        giftMessage = 'error';
        codeMessage = cfg.messages?.error || '';
        verified = -1;
        try { const result = await normalize(await request('cart.js')); await finish(result.cart, true, start); } catch (recoveryError) { failed = true; feedback(); }
      }
    });
  }
  function setGift(wanted) {
    return operation(async cart => {
      const s = state(cart);
      if (s.gifts.length) cart = await request('cart/update.js', { updates: Object.fromEntries(s.gifts.map(item => [item.key, 0])) });
      return normalize(cart, wanted);
    });
  }
  function applyCode(value) {
    const code = String(value || '').trim();
    if (!code) { codeMessage = cfg.messages?.empty || ''; if (lastCart && verified === revision) render(lastCart); return Promise.resolve(); }
    return operation(async cart => {
      const selected = state(cart).gifts.length > 0;
      cart = await request('cart/update.js', { discount: code });
      const result = await normalize(cart, selected);
      const record = (result.cart.discount_codes || []).find(item => (item.code || '').toUpperCase() === code.toUpperCase());
      if (!record || (!knownCodes.has(code.toUpperCase()) && record.applicable !== true) || (selected && giftMessage === 'paid')) codeMessage = cfg.messages?.invalid || '';
      return result;
    });
  }
  function removeCode() {
    return operation(async cart => {
      const selected = state(cart).gifts.length > 0;
      cart = await request('cart/update.js', { discount: '' });
      const result = await normalize(cart, selected);
      codeMessage = cfg.messages?.removed || '';
      return result;
    });
  }
  function formFields(form) {
    const scope = form?.id === 'CartDrawer-Form' ? document.querySelector('#CartDrawer') : document;
    const fields = Array.from(scope?.querySelectorAll('[name="note"], [name^="attributes["]') || []);
    const data = {}, attributes = {};
    fields.forEach(input => {
      if (input.disabled) return;
      const value = input.type === 'checkbox' || input.type === 'radio' ? (input.checked ? input.value : '') : input.value;
      if (input.name === 'note') data.note = value;
      else { const match = input.name.match(/^attributes\[(.+)\]$/); if (match) attributes[match[1]] = value; }
    });
    if (Object.keys(attributes).length) data.attributes = attributes;
    return data;
  }
  function checkout(form) {
    if (checkoutPromise) return;
    const inputs = Array.from(form?.querySelectorAll('.quantity__input') || []);
    if (inputs.some(input => !input.reportValidity())) return;
    inputs.forEach(input => { const edit = editFrom(input); if (edit && Number(input.value) !== Number(input.defaultValue)) edits.set(edit.key, edit); });
    const extra = formFields(form);
    invalidate();
    checkoutPromise = (async () => {
      if (edits.size) await new Promise(resolve => setTimeout(resolve, debounceMs + 120));
      for (let attempt = 0; attempt < 3; attempt++) {
        const done = await enqueue(async () => {
          const start = revision;
          let cart = await request('cart.js');
          for (const [key, edit] of Array.from(edits)) {
            if (!Number.isInteger(edit.quantity) || edit.quantity < 0) throw new Error('Invalid quantity');
            const item = lineFor(cart, edit);
            if (item && item.quantity !== edit.quantity) cart = await request('cart/change.js', { id: item.key, quantity: edit.quantity });
            if (edits.get(key) === edit) edits.delete(key);
          }
          if (Object.keys(extra).length) cart = await request('cart/update.js', extra);
          const result = await normalize(cart);
          if (start !== revision || writes > 0 || edits.size > 0) return false;
          await finish(result.cart, true, start);
          if (verified !== revision) return false;
          if (result.cart.item_count > 0) window.location.assign(rootUrl + 'checkout');
          return true;
        });
        if (done) return;
        await chain;
      }
      throw new Error('Cart is still changing');
    })().catch(() => { giftMessage = 'error'; codeMessage = cfg.messages?.error || ''; verified = -1; refresh(); }).finally(() => { checkoutPromise = null; feedback(); });
  }
  document.addEventListener('input', trackInput, true);
  document.addEventListener('change', event => {
    trackInput(event);
    if (!event.target.matches('[data-korol-fs-cb]')) return;
    event.stopPropagation();
    setGift(event.target.checked).catch(() => {});
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (target) {
      event.preventDefault(); event.stopImmediatePropagation();
      checkout(target.form || document.getElementById(target.getAttribute('form')) || target.closest('form'));
      return;
    }
    if (event.target.closest('[data-korol-fs-wirm]')) { event.preventDefault(); removeCode().catch(() => {}); }
    if (isLocked() && event.target.closest('.additional-checkout-buttons')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[action*="/cart"]') || event.target.matches('form[action*="/cart/add"]') || (event.submitter && event.submitter.name !== 'checkout')) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout(event.target);
  }, true);
  const observer = new MutationObserver(records => {
    if (!records.some(record => !record.target.closest?.('[data-korol-fs], [data-kw-code-box]') && (record.target.closest?.('cart-drawer, cart-items, #main-cart-footer') || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-korol-fs]') || node.querySelector('[data-korol-fs]')))))) return;
    invalidate();
    refresh();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart-drawer:updated'].forEach(name => document.addEventListener(name, () => { invalidate(); refresh(); }));
  window.addEventListener('pageshow', () => { invalidate(); refresh(); });
  window.KorolGift = Object.freeze({ applyCode, removeCode, refresh });
  document.dispatchEvent(new CustomEvent('korol-gift:ready'));
  refresh(0);
})();
